import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { CodeTitle, ICodeTitle } from "../common/codeTitle";

export interface IMessagePageData {
    canEditOtherCompanyPermissions: boolean;
    canEditModuleProperties: boolean;
    canEditAllModuleProperties: boolean;
    canEditMessages: boolean;
    units: IIdTitleNode[];
    filterCompanies: IIdTitle[];
    modifyUsers: ICodeTitle[];
}

export class MessagePageData implements IMessagePageData {
    canEditOtherCompanyPermissions: boolean;
    canEditModuleProperties: boolean;
    canEditAllModuleProperties: boolean;
    canEditMessages: boolean;
    units: IdTitleNode[];
    filterCompanies: IdTitle[];
    modifyUsers: CodeTitle[];

    constructor();
    constructor(obj: IMessagePageData);
    constructor(obj?: any) {
        this.canEditOtherCompanyPermissions = obj && obj.canEditOtherCompanyPermissions || false;
        this.canEditModuleProperties = obj && obj.canEditModuleProperties || false;
        this.canEditAllModuleProperties = obj && obj.canEditAllModuleProperties || false;
        this.canEditMessages = obj && obj.canEditMessages || false;
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        this.filterCompanies = Base.getTypedArray(obj ? obj.filterCompanies : null, IdTitle);
        this.modifyUsers = Base.getTypedArray(obj ? obj.modifyUsers : null, CodeTitle);
    }
}
